import { createApp } from 'vue';
import DownloadModal from "./DownloadModal.vue";
import { i18n } from '../../i18n';


const downloadModalEl = document.getElementById('download_modal');

if (downloadModalEl) {
  const app = createApp(DownloadModal);
  app.use(i18n);
  const vm = app.mount('#download_modal');
}
